import React, { Component } from 'react';
import { getColumnListForSearch, getFilterTranslations, getFilterValues, getValidations } from './configFilterStructure';
import FilterPane from 'Components/FilterPane';
import { getAppDataAccordingToSearchFilters } from 'Apis/appSearchApi';
import PropTypes from 'prop-types';
import GDTable from 'Components/GDTable';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import EmptyState from 'Components/EmptyState/EmptyState';
import {getTranslations } from '../CaseLanding/configStructure';
import './AppSearch.scss';
import ResponseBanner from 'Components/cards/ResponseBanner/ResponseBanner';
import { isObject } from 'util';
import moment from 'moment';
import GDDetailView from 'Components/GDDetailView';
import { connect } from 'react-redux';
import { setDrawerOpenFlag, setSearchOpenFlag } from 'Actions/drawerAction';
import { attachTransactionCase, postActiveFilters, undoAttachTransaction } from 'Apis/caseDataAPI.js';
import { exportDataSearchQueue } from 'Apis/exportApi';
import { fetchDataColumns } from 'Actions/dataColumnsAction'
import { getToken } from 'Apis/tokenizeFilterElement';
import { loadState } from '../../store/browserStorage';
import { downloadFile } from 'Utils/exportFunctionality.js';
import {
    dangerNotificationBanner,
    closeNotificationBanner,
} from 'Actions/notificationAction';
import * as KeyConstants from 'Utils/constants/keyConstants.js';
import { getSortArray } from 'Utils/sortArrayUtil.js'
import { getRelatedTransactionData } from 'Apis/referenceDataApi.js';
import { flushSync } from 'react-dom';
import {
    queueMetaData,
    addIconsToGDTableHeadersList,
  } from '../QueueManagementLanding/configStructure';
  import GridAccordion from 'Components/GridAccordion/GridAccordion';
  import Button from 'Components/Button/Button';
  import { toggleAppSearchPanelAction, setRelatedGridLoadedAction, setDataSearchTrasactionGridProp } from 'Actions/toggleAppSearchPanelAction';
import { getAcquirerAccessList } from 'Utils/permissionsUtils';
import { isEmpty } from 'Utils/lodashUtils';
import { VITE_TRANSACTION_DATE_KEY, VITE_MERCHANT_NUMBER_KEY, VITE_AUTH_DATE_KEY,  } from 'Constants/appEnvConstants';
import ImagePortal from '../ImagePortal/ImagePortal';

let searchFilterValues;
var globalToken;
const __OP1_REASON_CODE__ = 'OP1';
export class AppSearch extends Component {

    constructor(props) {
        super(props);
        this.state ={
           ...this.getInitialState(),
           global_token:'',
        }, 
        this.attachBindings();
        }

    attachBindings() {
        this.toggleFilterPane = this.toggleFilterPane.bind(this);
        this.closeFilterPane = this.closeFilterPane.bind(this);
        this.resetScrollPos = this.resetScrollPos.bind(this);
        this.applyFilters = this.applyFilters.bind(this);
        this.closeBanner = this.closeBanner.bind(this);
        this.rowActionClick = this.rowActionClick.bind(this);
        this.toggleDrawer = this.toggleDrawer.bind(this);
        this.getColumnListForTableById = this.getColumnListForTableById.bind(this);
        this.getFilterValuesById = this.getFilterValuesById.bind(this);
        this.getFiltersBasedOnSearchTypeId = this.getFiltersBasedOnSearchTypeId.bind(this);
        this.getInitialState = this.getInitialState.bind(this);
        this.setFilterModelAttribute = this.setFilterModelAttribute.bind(this);
        this.saveCurrentlyVisibleColumns = this.saveCurrentlyVisibleColumns.bind(this);
        this.addIconsToGDTableHeadersList = this.addIconsToGDTableHeadersList.bind(this);
        this.undoAttachedTransaction = this.undoAttachedTransaction.bind(this);
        this.getTokenFromCardNumber = this.getTokenFromCardNumber.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.getAcquireCode=this.getAcquireCode.bind(this);
        this.getDefaultSortArray=this.getDefaultSortArray.bind(this);
    }


    UNSAFE_componentWillMount() {
        this.props.fetchDataColumns(this.getColumnListForTableById().pageId, "AppSearch");
        this.setUpdatedTransactionSearchResults();
        document.addEventListener('keydown', this.onKeyPress);
        document.addEventListener('keypress', this.onKeyPress);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeyPress);
        document.removeEventListener('keypress', this.onKeyPress);
    }

    onKeyPress(event) {
        const eventCode = event.code ? (event.code + '_' + event.ctrlKey) : event.key + '_' + event.ctrlKey;
        switch (eventCode) {
            case KeyConstants.ESCAPE_BUTTON:
            case KeyConstants.ESCAPE_KEY_CODE_BUTTON:
                this.closeBanner();
                break;
            case KeyConstants.CTRL_ALT_DIGIT0:
            case KeyConstants.CTRL_ALT_NUMPAD0:
                document.getElementById('selectDataSearch') && document.getElementById('selectDataSearch').click();
                break;
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props?.dataColumns?.length !== nextProps.dataColumns?.length) {
            this.setState({
                dataColumns: this.addIconsToGDTableHeadersList(nextProps.dataColumns)
            })
        }

        if (window.location.href !== this.state.currentLocation) {
            this.setUpdatedTransactionSearchResults();
        }
        if ( (nextProps.isRelatedTransactionGridOpen && !nextProps.isRelatedTransactionGridLoaded ) ) {
            this.props.setRelatedGridLoadedAction(true);
            this.setState({
                gridSortArray: [
                    {
                      key: "transactionDate",
                      order: 1
                    }
                ]
            },
            ()=> {
                this.getRelatedTransactionData();
            })
        }
    }

    setActionButtonStyleAsBlock(data) {
        let structureMetaData = data;
        if (this.props.searchTypeId == 1 || data.pageId == "related_transactions") {
            structureMetaData.actions[1].style.display = "block";
        }
        return structureMetaData;
    }

    setUpdatedTransactionSearchResults() {
        this.setState({
            structureMetaData: { ...(this.props.addCurrentCaseNumber > 0 ? this.setActionButtonStyleAsBlock(this.getColumnListForTableById()) : this.getColumnListForTableById()), dataColumns: this.state.dataColumns },
            currentLocation: window.location.href,
        });
    }

    getDefaultSortArray(searchTypeId) {
        console.log('searchTypeId', searchTypeId);  
        switch (searchTypeId) {
            case "1": 
                return ([{
                    key: VITE_TRANSACTION_DATE_KEY,
                    order: 0,
                }]);
            case "2":
                return ([{
                    key: VITE_AUTH_DATE_KEY,
                    order: 0,
                }]);
            case "3":                 
                return ([{
                    key: VITE_MERCHANT_NUMBER_KEY,
                    order: 0,
                }]);
            default :
                return ([{
                    key: VITE_TRANSACTION_DATE_KEY,
                    order: 0,
                }]);
        }
    }
    
    componentDidUpdate(oldProps) {
        // // Typical usage (don't forget to compare props):
        if (oldProps.addCurrentCaseNumber !== this.props.addCurrentCaseNumber) {
            this.setUpdatedTransactionSearchResults();
        }

        if (oldProps.searchTypeId !== this.props.searchTypeId) {
            this.setState({
                ...this.getInitialState(),
                searchTypeId: this.props.searchTypeId,
                dataColumns: [],
            }, () => {
                this.props.fetchDataColumns(this.getColumnListForTableById().pageId, "AppSearch");
            });
            scroll(0, 0);
            this.getFiltersBasedOnSearchTypeId();
        }
    }

    // First load all filter related to id.
    componentDidMount() {
        scroll(0, 0);
        this.getFiltersBasedOnSearchTypeId();
    }

    getInitialState() {
        return {
            isVisible: true,
            activeFilters: [],
            filters: [],
            isLoading: true,
            scrollPos: 0,
            totalPages: 0,
            structureMetaData: {},
            caseData: [],
            totalRecords: 0,
            recordsShown: 0,
            currentPage: 0,
            isNextPage: false,
            isPrevPage: true,
            dataTransactionGridStatus: true,
            caseDataErr: false,
            exporting: false,
            filterExportIsVisible: false,
            appliedFilters: [],
            dateFormat: 'MM/DD/YYYY',
            filterText: '',
            savedFilterTranslations: {},
            isRequiredFilter: false,
            isTableVisible: false,
            drawerOpen: false,
            selectedKeyIndex: 0,
            searchTypeId: this.props.searchTypeId,
            apiUrl: '',
            bannerDescription: '',
            isLoadingComplete: true,
            isTransactionCaseAttached: false,
            isTransactionCaseAttachedError: false,
            currentLocation: '',
            dataColumns: [],
            attachedTransactionId: null,
            isTransactionUnattached: false,
            setSize: false,
            gridSortArray: this.getDefaultSortArray(this.props.searchTypeId),
            isGridOpen: true,
            isAccordionOpen: true,
            isFirstCall: true,
        };
    }
    toggleDrawer = () => {
        document.body.style.overflow = 'visible';
        this.props.setDrawerOpenFlag(false);
        this.setState({
            drawerOpen: !this.state.drawerOpen,
        });
    }

    toggleThisAccordion = () => {
        this.setState({ isAccordionOpen: !this.state.isAccordionOpen });
    }
    
    onCloseButtonClick = () => {
        this.props.setSearchOpenFlag(false);
        this.props.setDataSearchTrasactionGridProp(false, true, false);
        this.props.setSearchType(null);
        this.props.toggleAppSearchPanelAction(false);
        this.props.setRelatedGridLoadedAction(false);
        this.setState({
            isGridOpen: false,
            caseData: [],
        }, () => {this.props.setDataSearchTrasactionGridProp(false, true, false)});
    }

    rowActionClick(selectedKeyIndex, key) {
        switch (key) {
            case 'DETAIL_DRAWER':
                this.setState({
                    drawerOpen: true,
                    selectedKeyIndex,
                });
                this.props.setDrawerOpenFlag(true);
                break;
            case 'OPEN_CASE':
                this.setState({
                    drawerOpen: true,
                    selectedKeyIndex,
                });
                this.props.setDrawerOpenFlag(true);
                break;
            case 'ATTACH_CASE':
                attachTransactionCase(this.state.caseData[selectedKeyIndex], this.props.addCurrentCaseNumber).then((apiResponse) => {
                    this.setState({
                        selectedKeyIndex,
                        isTransactionCaseAttached: true,
                        isTransactionCaseAttachedError: false,
                        bannerDescription: (
                            this.state.caseData[selectedKeyIndex].transactionIdentifier == null 
                                ? `Transaction has been successfully attached to Case ${this.props.addCurrentCaseNumber}`
                                : `Transaction ${this.state.caseData[selectedKeyIndex].transactionIdentifier} has been successfully attached to Case ${this.props.addCurrentCaseNumber}`
                        ),
                        attachedTransactionId: apiResponse.data,
                    });
                })
                    .catch(error => {

                        if (error.response.status == 4000 || error.response.status == 400) {
                            this.setState({
                                bannerResponseMessage: `This Case is already Attached `,
                                isTransactionCaseAttached: false,
                                isTransactionCaseAttachedError: true,
                                attachedTransactionId: null,
                            });
                            console.error('Error Occured while attaching transaction to case', error);
                        } else {
                            this.setState({
                                bannerResponseMessage: `Failed to attach the transaction to a case.`,
                                isTransactionCaseAttached: false,
                                isTransactionCaseAttachedError: true,
                                attachedTransactionId: null,
                            });
                            console.error('Error Occured while attaching transaction to case', error);
                        }
                    });
                break;
            default:
                break;
        }
    }
    // Return Filter panel object for search
    getFilterValuesById() {
        const searchTypeId = this.props.searchTypeId;
        this.setState({
            searchTypeId,
        });
        searchFilterValues = getFilterValues().data;
        for (let i = 0; i < searchFilterValues.length; i++) {
            if (searchFilterValues[i].filterTypeId == searchTypeId) {
                return searchFilterValues[i];
            }
        }
    }
    goToNextRecord = () => {
        this.state.selectedKeyIndex + 1 < this.state.caseData.length && this.setState((prevState) => ({
            selectedKeyIndex: prevState.selectedKeyIndex + 1,
        }));
    };

    goToPreviousRecord = () => {
        this.state.selectedKeyIndex > 0 && this.setState((prevState) => ({
            selectedKeyIndex: prevState.selectedKeyIndex - 1,
        }));
    };

    // Input elements for filter panel search
    getFiltersBasedOnSearchTypeId() {
        searchFilterValues = this.getFilterValuesById();
        if (searchFilterValues !== undefined) {
            const filterElements = searchFilterValues.filterElements;
            filterElements.map((filter) => {
                return Object.assign(filter, {
                    validations: getValidations(filter.elementTypeName) != undefined ? getValidations(filter.elementTypeName).validations : [],
                });
            });
            let appliedFilters = [{fieldId: 'acquirerCode', fieldValues1: this.getAcquireCode()}, {fieldId: 'merchantNumber', fieldValues1: [this.props.merchantDetails.merchantNumber]},{fieldId: 'globalToken', fieldValues1: [this.props.merchantDetails.globalToken]}];

            this.setState({
                caseDataErr: false,
                isLoading: false,
                filters: filterElements,
                apiUrl: searchFilterValues.apiUrl,
                appliedFilters
            });
        }
    }

    /* This method is responsible for fetching the list of elemnt to be show on table
    and drawer after search which returns search object */
    getColumnListForTableById() {
        const searchTypeId = this.props.isRelatedTransactionGridOpen ? 4 : (this.props.searchTypeId == null || this.props.searchTypeId == undefined) ? this.state.searchTypeId : this.props.searchTypeId;
        const filterList = getColumnListForSearch();
        for (let i = 0; i < filterList.length; i++) {
            if (filterList[i].id == searchTypeId) {
                return filterList[i];
            }
        }
    }

    getAcquireCode = () => {
        const dataArray = this.props.stageType.map(e=> e.caseDetail);
        const foundObject = dataArray.find(item => item.caseNumber === this.props.addCurrentCaseNumber);
        if (foundObject) {
            return foundObject.acquirerName;
        } else {
            return 'No matching case number found';
        }
    }

    getRelatedTransactionData = (args) => {
        let size = 25;
        const auth = loadState('auth');
        const userPermission = auth.user.parsedPermissions;
        const queueMetaDataClone = { ...queueMetaData(userPermission, null, true) };
        queueMetaDataClone.dataColumns = [...addIconsToGDTableHeadersList(this.state.dataColumns, null)];
        this.props.setDataSearchTrasactionGridProp(false, true, false);

        const structureMetaData = this.state.structureMetaData;
        structureMetaData.dataColumns = this.addIconsToGDTableHeadersList(this.state.dataColumns);
        let newSortArray = args?.sortArray != null ? args?.sortArray : this.state.gridSortArray;
        this.setState({
            caseData: [],
            isTableVisible: false,
            isLoading: true,
            caseDataErr: false
        },
            () => {
                return getRelatedTransactionData({
                    globalToken: this.props.merchantDetails.globalToken,
                    merchantNumber: this.props.merchantDetails.merchantNumber,
                    acquirerCode: this.getAcquireCode(),
                    pageNumber: args?.pageNumber ? args?.pageNumber : 0,
                    size: args?.size ? args?.size : size,
                    sortArray: newSortArray,
                })
                .then((apiResponse) => {
                  const formattedData = apiResponse.data.content;
                  this.setState({
                    structureMetaData,
                    queueMetaData: queueMetaDataClone,
                    caseData: formattedData,
                    totalRecords: apiResponse.data.totalElements,
                    totalPages: apiResponse.data.totalPages,
                    currentPage: apiResponse.data.number + 1,
                    recordsShown: args?.size ? args?.size : size,
                    isNextPage: !apiResponse.data.last,
                    caseDataErr: false,
                    isLoading: false,
                    agLoader: false,
                    userPermission,
                    statusErrorCode: apiResponse.status.statusCode,
                    isTableVisible: true,
                    gridSortArray: newSortArray,
                    isGridOpen: true,
                    dataTransactionGridStatus: false
                  }, () => {this.props.setDataSearchTrasactionGridProp(false, true, false);}
                  );
                  
                  scroll(0, 0);
                })
                .catch((error) => {
                  this.setState({ isTableVisible: false, isLoading: false, caseDataErr: true, statusErrorCode: error.response.status });
                  console.log('Error Occured while fetching data for related search', error);
                });
            }
        )

    }

    // API call for fetching data from the backend
    getAppDataAccordingToSearchFilters(filters, pageNumber, size, sortArray, url, lazyLoad) {
        const structureMetaData = this.state.structureMetaData;
        structureMetaData.dataColumns = this.addIconsToGDTableHeadersList(this.state.dataColumns);
        this.props.setDataSearchTrasactionGridProp(true, this.state.isPrevPage, this.state.isNextPage);
        
        const dateFormat = structureMetaData.dateFormat;
        if (sortArray == null || sortArray == undefined) {
            sortArray = structureMetaData.defaultSort;
            this.setState({
                gridSortArray: sortArray,
            });
        }
        const filterObject = this.setFilterModelAttribute(filters, pageNumber, size, sortArray, dateFormat);
        if (filterObject !== undefined) {
            this.setState({
                caseData: [],
                isTableVisible: false,
                isLoading: true
            },
                () => {
                    if(lazyLoad === true){
                        return getAppDataAccordingToSearchFilters(filterObject, url)
                        .then((apiResponse) => {
                            const formattedData = apiResponse.data.content;
                            this.setState((prevState) => ({
                                structureMetaData,
                                caseData: formattedData,
                                totalRecords: apiResponse.data.totalElements,
                                totalPages: apiResponse.data.totalPages,
                                currentPage: apiResponse.data.number + 1,
                                recordsShown: size,
                                isNextPage: true,
                                isPrevPage:  false,
                                caseDataErr: false,
                                isLoading: false,
                                gridSortArray: sortArray,
                                isTableVisible: true,
                                //  lazyLoadPageNumber: apiResponse.data.number,
                                agLoader: false,
                            }), () => {this.props.setDataSearchTrasactionGridProp(this.state.dataTransactionGridStatus, this.state.isPrevPage, this.state.isNextPage)})
                        })
                        .catch((error) => {
                            this.setState({ isTableVisible: false, caseDataErr: true, isLoading: false });
                            console.log('Error Occured while fetching data based on applied filters', error);
                        });
                    }else{
                        this.setState((prevState) => ({
                            structureMetaData,
                            recordsShown: size,
                            isNextPage: true,
                            isPrevPage:  false,
                            caseDataErr: false,
                            isLoading: false,
                            gridSortArray: sortArray,
                            isTableVisible: true,
                            agLoader: false,
                        }), () => {this.props.setDataSearchTrasactionGridProp(this.state.dataTransactionGridStatus, this.state.isPrevPage, this.state.isNextPage)})
                    }

                }
            )
        }
    }

    pageHandler = (newPage, newPerPage) => {
        this.setState({
            isLoading: true,
        });
        scroll(0, 0);
        const pageSize = newPerPage === undefined ? this.state.recordsShown : newPerPage;
        if (newPage) {
            if(this.props.isRelatedTransactionGridOpen) {
                this.getRelatedTransactionData({ pageNumber: newPage - 1, size: pageSize })
            } else {
                this.getAppDataAccordingToSearchFilters(this.state.appliedFilters, newPage - 1, pageSize, this.state.gridSortArray, this.state.apiUrl, false);
            }
        }
    }

    toggleFilterPane = () => {
        document.body.classList.add('instant-header');
        scroll(0, 0);
        this.setState(
            {
                isVisible: !this.state.isVisible,
            },
        );
    }

    mapActiveFilters(filters = [], data = []) {
        const results = [];
        filters.forEach((filter) => {
            const matchingFilter = data.find((column) => (column.elementId) === (filter.id));
            if (matchingFilter &&
                matchingFilter.elementLabel) {
                results.push(
                    Object.assign({}, filter, {
                        name: matchingFilter.elementLabel,
                        value: !filter.v2 ? filter.v1 : null,
                        values: filter.v2 ? { v1: filter.v1, v2: filter.v2 } : null,
                        v1: filter.v1,
                        v2: filter.v2,
                    }),
                );
            }
        });
        return results;
    }

    applyFilters(newValues, filterList) {
        this.props.setSearchOpenFlag(true);
        const filterJSON = this.getColumnListForTableById();
        const newFilterValues = Object.keys(newValues).map((key) => {
            return Object.assign({}, newValues[key], { id: key });
        });

        const dateFilter = filterList.filter((filter) => {
            return filter.elementMandatory === true;
        });

        const isDatePresent = newFilterValues.filter((filter) => {
            return (filter.id === "fromTransactionDate" || filter.id === "fromAuthorizationDate");
        });

        const isMerchantHierarchy = newFilterValues.filter((filter) => {
            return filter.id === "merchant_hierarchy";
        });
        const isAcquirerName = newFilterValues.filter((filter) => {
            return filter.id === "acquirerCode";
        });


        if (isDatePresent.length < 1) {

            const yesterDay = moment().subtract(1, 'days');
            const newDate = moment(yesterDay).subtract(3, 'months');

            const fromDate = moment(newDate).format(this.state.dateFormat);
            const endDate = moment(yesterDay).format(this.state.dateFormat);

            const currentValuesObj = dateFilter.reduce((obj, value) => {
                return Object.assign(obj, {
                    type: "BETWEEN",
                    v1: fromDate,
                    v2: endDate,
                    error: "",
                    flag: false,
                    id: value.elementId,
                });
            }, {});

            newFilterValues.push(currentValuesObj);
        }

        const newActiveFilters = this.mapActiveFilters(
            newFilterValues,
            this.state.filters,
        );
        let minFieldLength = newFilterValues.length;
        let fullAccountNumberPresent = false;
        if (newValues.cardNumber && newValues.globalToken) {
            minFieldLength--;
        }
        if (newValues.globalToken) {
            fullAccountNumberPresent = true;
        }
       console.log(minFieldLength);
        if ((filterJSON.minMandateField && minFieldLength < 3 && isMerchantHierarchy.length !== 0) || (filterJSON.minMandateField && minFieldLength < 2)) {

            this.setState({
                isRequiredFilter: true,
                bannerDescription: `At least 1 Field is required other than ${dateFilter[0].elementLabel} for the search.`,
                isVisible: true,
            });
        }
        else if (isAcquirerName[0]?.v1?.length <1 || isAcquirerName == []) {
            this.setState({
                isRequiredFilter: true,
                bannerDescription: `At least one Acquirer Name needs to be selected for the search.`,
                isVisible: true,
            });
        }
        else if (filterJSON.minMandateField == false && !isEmpty(isAcquirerName[0]?.v1) && minFieldLength < 3 )  {  
            this.setState({
                isRequiredFilter: true,
                bannerDescription: `At least 2 Fields are required for the search.`,
                isVisible: true,
            });
        }
        else if (minFieldLength < 3 && !isEmpty(isAcquirerName[0]?.v1) )  {  
            this.setState({
                isRequiredFilter: true,
                bannerDescription: `At least 1 Field is required apart from ${dateFilter[0].elementLabel} and Acquirer Name for the search.`,
                isVisible: true,
            });
        }

        else if (filterJSON.minMandateField == false && minFieldLength == 0) {
            this.setState({
                isRequiredFilter: true,
                bannerDescription: `Atleast one field is required for search`,
                isVisible: true,
            });
        }
        else {
            const filters = [];
            newActiveFilters.forEach((newActiveFilter) => {
                const filter = {
                    fieldId: newActiveFilter.id,
                    fieldValues1: newActiveFilter.v1 !== undefined ? this.setFieldValue(newActiveFilter) : '',
                    fieldvalue2: (newActiveFilter.v2 && newActiveFilter.name.includes('Date')) ? this.changeDateFormat(newActiveFilter.v2) : newActiveFilter.v2,
                };
                if ((newActiveFilter.v1 !== undefined && newActiveFilter.v1.length != 0) || newActiveFilter.v2 !== undefined) { filters.push(filter); }
            });
            const updateIndex = filters.findIndex((caseObject) => {
                return caseObject.fieldId === 'fromTransactionAmount';
            });
            if (filters.length !== 0 && !(updateIndex == 0 && filters.length == 1)) {
                this.setState({
                    appliedFilters: filters,
                    isVisible: false,
                    activeFilters: newActiveFilters,
                    isLoading: true,
                    isRequiredFilter: false,
                });
                if (fullAccountNumberPresent) {
                    globalToken = newValues.globalToken.v1;
                    this.getTokenFromCardNumber(filters, globalToken);
                } else {
                    globalToken = undefined;
                    this.getAppDataAccordingToSearchFilters(filters, 0, this.getColumnListForTableById().pageSize, this.state.gridSortArray, this.state.apiUrl, false);
                }
            } else {
                this.setState({
                    isRequiredFilter: true,
                    isVisible: true,
                });
            }
        }
        scroll(0, 0);
  }

    getTokenFromCardNumber(filters, cardNumber) {
        return getToken(cardNumber)
            .then((apiResponse) => {
                if (apiResponse.status.statusCode === 2000) {
                    this.setState({ global_token: apiResponse.data.GlobalToken })
                    let filterClone = filters.map((filter) => (filter.fieldId === 'globalToken' ? {                   
                        ...filter, fieldValues1: [apiResponse.data.GlobalToken]
                    } : { ...filter }));
                    this.getAppDataAccordingToSearchFilters(filterClone, 0, this.getColumnListForTableById().pageSize, this.state.gridSortArray, this.state.apiUrl, false);
                    this.setState({ appliedFilters: filterClone })
                }
            })
            .catch((error) => {
                this.setState({ isLoading: false });
                console.log('Error Occured while tokenizing Card Number', error);
            });
    }

    saveCurrentlyVisibleColumns(columns) {
        this.setState({
            dataColumns: columns
        })
        let activeDataColumns = [];
        columns.forEach((column) => {
            if (column.displayType !== "ICON") {
                let activeColumn = {
                    columnId: column.columnId,
                    displayOrder: column.displayOrder
                }
                activeDataColumns.push(activeColumn);
            }
        })
        this.postActiveFilters(activeDataColumns);
    }

    postActiveFilters(columns) {
        return postActiveFilters(this.getColumnListForTableById().pageId, columns)
            .then((apiResponse) => {
                this.setState({
                    caseDataErr: false,
                    isLoading: false,
                })
            })
            .catch((error) => {
                this.setState({ caseDataErr: true, isLoading: false });
                console.log('Error Occured while saving active data columns', error);
            });
    }

    addIconsToGDTableHeadersList(columns) {
        let iconsColumns = columns.find(column => column.displayType == "ICON" && column.description == "");
        if (!iconsColumns) {
            columns.push({
                "defaultIsVisible": true,
                "description": '',
                "isRequired": false,
                "isSortable": false,
                "isSummaryColumn": false,
                "name": '',
                "sortDirection": null,
                "sortOrderPriority": 0,
                "displayType": 'ICON',
                "columnKey": 'FolderIcon',
                "displayOrder": 100,
                "isSelected": true,
            })

        }
        return columns;
    }


    setFieldValue(newActiveFilter) {
        if (newActiveFilter.name.includes('Date') && newActiveFilter.v1.split('/').length > 1) { return this.changeDateFormat(newActiveFilter.v1).split(); }
        return !isObject(newActiveFilter.v1) ? newActiveFilter.v1.split() : newActiveFilter.v1;
    }
    /*
        This method returns model object for the app search apis.
    */
    setFilterModelAttribute(filters, pageNumber, pageSize, sortArray, dateFormat) {
        const filterObject = {};
        filters.forEach((filter) => {
            if (filter.fieldId == 'cardNumber') {
                if (filter.fieldValues1[0] != null && filter.fieldValues1[0] !== '') {
                    filterObject.firstSixDigitsCardNumber = filter.fieldValues1[0];
                    if (filter.fieldvalue2 != null && filter.fieldvalue2 !== '') {
                        filterObject.lastFourDigitsCardNumber = filter.fieldvalue2;
                    }
                } else if (filter.fieldvalue2 != null && filter.fieldvalue2 !== '') {
                    filterObject.lastFourDigitsCardNumber = filter.fieldvalue2;
                    if (filter.fieldValues1[0] != null && filter.fieldValues1[0] !== '') {
                        filterObject.firstSixDigitsCardNumber = filter.fieldValues1[0];
                    }
                }
            } else if (filter.fieldId.indexOf('from') != -1 && filter.fieldId.indexOf('Amount') != -1) {
                filterObject[filter.fieldId] = filter.fieldValues1[0];
                const toDate = filter.fieldId.replace('from', 'to');
                if (filter.fieldvalue2 !== undefined && filter.fieldvalue2 !== null && filter.fieldvalue2 !== '') { filterObject[toDate] = filter.fieldvalue2; }
            } 
            else  if (filter.fieldId == 'acquirerCode') {
                if ((filter.fieldValues1[0] != null && filter.fieldValues1[0] !== '')||(filter.fieldValues2[0] != null && filter.fieldValues2[0] !== '' )) {
                    filterObject[filter.fieldId] =filter.fieldValues1;
                    
                }
            }
            else {
                filterObject[filter.fieldId] = filter.fieldId.indexOf('Date') != -1 && (moment(filter.fieldValues1[0], 'MM/DD/YYYY', true).isValid()) ? moment(filter.fieldValues1[0]).format(dateFormat) : filter.fieldValues1[0];
            }
            if (filter.fieldId.indexOf('Date') != -1 && filter.fieldvalue2 !== undefined && filter.fieldvalue2 !== 'Invalid date') {
                const toDate = filter.fieldId.replace('from', 'to');
                filterObject[toDate] = moment(filter.fieldvalue2).format(dateFormat);
            }
        });
        if (filterObject !== undefined && sortArray !== undefined) {
            filterObject.size = pageSize;
            filterObject.pageNumber = pageNumber;
            filterObject.sort = sortArray;

        }
        return filterObject;
    }

    changeDateFormat(field) {
        const dateFormat = 'MM/DD/YYYY';
        return moment(field).format(dateFormat);
    }

    closeFilterPane = () => {
        scroll(0, 0);
        this.props.setSearchOpenFlag(false);
        this.setState({ isVisible: false });
        this.props.setSearchType(null);
        this.props.setDataSearchTrasactionGridProp(false, true, false)
    }

    resetScrollPos() {
        this.state.scrollPos = 0;
    }

    exportAction = (fileObject) => {
        this.toggleFileExport();
        let isAllColumns = fileObject.exportType.value === 'all-columns' ? true : false;
        let fileType = fileObject.fileType.value;
        let fileName = fileObject.fileName;
        this.state.totalRecords > 25000 ?
            this.setState({
                setSize: true,
            })
            :
            this.exportFile(fileName, fileType, isAllColumns);
    }
    exportFile(fileName, fileType, isAllColumns) {
        const sortObj = this.state.gridSortArray.map(obj => {
            return {
                fieldId: obj.key,
                orderByProperty: (obj.order) ? 'ASC' : 'DESC',
            }
        })
        let sortKey = '';
        let sortOrder = '';

        sortObj.forEach((sortElement, sortElementIndex) => {
            sortKey = `${sortKey}${sortElementIndex === 0 ? '' : ','}${sortElement.fieldId}`;
            sortOrder = `${sortOrder}${sortElementIndex === 0 ? '' : ','}${sortElement.orderByProperty}`
        });

        let searchInput = {};
        if (this.getColumnListForTableById().pageId == "related_transactions") {
            searchInput['globalToken'] = this.props?.merchantDetails?.globalToken;
            searchInput['merchantNumber'] = this.props?.merchantDetails?.merchantNumber;
            searchInput['acquirerCode'] = [this.getAcquireCode()];
        } else {
            this.state.activeFilters.forEach((value) => {
                if (((value.id === "fromAuthorizationDate") || (value.id === "fromTransactionDate")) && value.type === "BETWEEN") {
                    const dateFormat = "YYYY-MM-DD";
                    searchInput[value.id] = moment(value.v1).format(dateFormat);
                    searchInput[value.id.replace('from', 'to')] = moment(value.v2).format(dateFormat);
                }
                else if((value.id === "globalToken")){
                       searchInput['globalToken'] = this.state.global_token;
                }
                else if((value.id === "cardNumber")){
                           searchInput[value.id.replace('cardNumber','firstSixDigitsCardNumber')] = value.v1;
                           searchInput[value.id.replace('cardNumber','lastFourDigitsCardNumber')] = value.v2;
                }
                else {
                    searchInput[value.id] = value.v1
                }
                
            })
        }
        let queueExportData = {
            fileType: fileType,
            isAllColumns: isAllColumns,
            pageId: this.getColumnListForTableById().pageId,
            [this.getColumnListForTableById().exportSearchInputName]: {
                pageNumber: 0,
                orderByProperties: sortKey,
                direction: sortOrder,
                size: this.state.totalRecords,
                ...searchInput
            },
            type: this.getColumnListForTableById().exportType
        }
        this.setState({ exporting: true });
        exportDataSearchQueue(queueExportData, this.getColumnListForTableById().exportType).then((response) => {//api name to be changed
            downloadFile(fileName, fileType, response);
            this.setState({ exporting: false });
        })
            .catch((error) => {
                this.setState({ exporting: false });
                console.log('Error Occured while exporting the case', error);
            });
    }
    checkSize() {
        this.props.setNotification([{
            title: `Error Occured`,
            descriptionStyle: "color: 'grey'",
            description: 'Your export request has exceeded the limitation of 25,000 rows.  Please apply additional filters to reduce of number rows.',
            type: 'danger',
            noActions: true,
            cancelOnly: true,
            closeNotification: () => this.props.closeNotification(),
        }]);
        this.setState({
            setSize: false,
        })
    }

    onSearchChange = (filterText) => {
        this.setState({ filterText });
    }

    handleSort = (key, sortArray) => {
        if(this.props.isRelatedTransactionGridOpen){
            this.getRelatedTransactionData({sortArray})
        } else {
            this.getAppDataAccordingToSearchFilters(this.state.appliedFilters, 0, this.state.recordsShown, sortArray, this.state.apiUrl, false);
        }

    }

    toggleFileExport = () => {
        this.setState({ filterExportIsVisible: !this.state.filterExportIsVisible });
    }

    closeBanner = () => {
        this.setState({
            isRequiredFilter: false,
            isTransactionCaseAttached: false,
            isTransactionCaseAttachedError: false,
            isTransactionUnattached: false,
        });
    }
    loadDataOnScroll = () => {
        if (!(this.state.totalRecords - this.state.caseData.length <= 0)) {
            this.getAppDataAccordingToSearchFilters(this.state.appliedFilters, this.state.lazyLoadPageNumber + 1, this.state.recordsShown, this.state.gridSortArray, this.state.apiUrl, true);
        } else {
            this.setState({
                isLoadingComplete: false,
            });
        }
    };
    undoAttachedTransaction() {
        return undoAttachTransaction(this.props.addCurrentCaseNumber, this.state.attachedTransactionId)
            .then((apiResponse) => {
                if (apiResponse.status.statusCode === 2000) {
                    this.closeBanner();
                    this.setState({
                        isTransactionCaseAttachedError: false,
                        attachedTransactionId: null,
                        isTransactionUnattached: true,
                        bannerResponseMessage: "Transaction Unattached Successfully."
                    });
                }
            })
            .catch((error) => {
                this.closeBanner();
                this.setState({
                    isTransactionCaseAttachedError: true,
                    bannerResponseMessage: "Error Unattaching Transaction",
                    attachedTransactionId: null,
                });
                console.log('error while removing attached transaction to case', error);
            });
    }

    setDataError = () => {
        this.setState({
            caseDataErr: true,
        })
    }

    setRecordCount = (recordCount, totalRecords, sortArray) => {
        this.setState({
            recordsShown: recordCount,
            totalRecords: totalRecords,
            gridSortArray: sortArray
        })
    }

  setAggridCaseData = (data, pageNum, sortArray) => {
    this.setState((prevState) => ({
      caseData: (this.state.isFirstCall || pageNum == 1) ? data : prevState.caseData.concat(data),
      isFirstCall: false,
      gridSortArray: sortArray,
    }))
  };

    serverSideData = (props, thisObject) => {
        let currentComponentThis = this
        return {
            getRows(params) {
                const newSortArray = params?.api?.getColumnState()
                ?.filter(ele => ele?.sort)
                ?.map(({ colId, sort }) => ({ key:colId, order: sort === 'asc' ? 1 : 0 }));

                const filterObject = props.setFilterModelAttribute(props.appliedFilterParams, thisObject.state.pageNumber, 25, newSortArray, 'YYYY-MM-DD');
                const totalRecords = thisObject.state?.totalRecords || 0;
                if (!thisObject.state.isSortClicked) {
                    if (globalToken) {
                        return getToken(globalToken)
                            .then((apiResponse) => {
                                if (apiResponse.status.statusCode === 2000) {
                                    let filterClone = props.appliedFilterParams.map((filter) => (filter.fieldId === 'globalToken' ? {
                                        ...filter, fieldValues1: [apiResponse.data.GlobalToken]
                                    } : { ...filter }));
                                    const updatedPageNumber = thisObject.state.isColumnChanged ? 0 : thisObject.state.pageNumber;
                                    getAppDataAccordingToSearchFilters(props.setFilterModelAttribute(filterClone, updatedPageNumber, 25, newSortArray, 'YYYY-MM-DD'), props.appSerchUrl)
                                    .then((apiResponse) => {
                                        let count = apiResponse.data.pageable.offset + apiResponse.data.numberOfElements;
                                        props.setRecordCount(count, apiResponse.data.totalElements, newSortArray);
                                        const pageNum = updatedPageNumber + 1;
                                        const formattedData = apiResponse.data.content;
                                        props.setAggridCaseData(formattedData, pageNum, newSortArray);
                                        flushSync(()=> {
                                          thisObject.setState({
                                            pageNumber: pageNum,
                                            isLoading: false,
                                            isSortClicked: false,
                                            isColumnChanged: false,
                                          });
                                        });
                                        const isLastPage = apiResponse?.data?.last;
                                        const rowCount = isLastPage ? (apiResponse.data.pageable.offset + formattedData.length) : undefined;
                                        params.success({
                                          rowData: formattedData,
                                          rowCount: rowCount,
                                        });
                                        setTimeout(() => {
                                            thisObject.autoSizeAllColumns(params?.api?.getColumnDefs());
                                        }, 100);
                                    })
                                    .catch((error) => {
                                        props.setDataError();
                                        flushSync(()=> {
                                          thisObject.setState({
                                            isSortClicked: false,
                                            isColumnChanged: false,
                                          });
                                        });
                                        params.fail();
                                        console.log('Error Occured while fetching unmatched case details', error);
                                    });
                                }
                            })
                            .catch((error) => {
                                this.setState({ isLoading: false });
                                console.log('Error Occured while tokenizing Card Number', error);
                            });
                    }
                    else {
                        return getAppDataAccordingToSearchFilters(filterObject, props.appSerchUrl)
                            .then((apiResponse) => {
                                let count = apiResponse.data.pageable.offset + apiResponse.data.numberOfElements;
                                props.setRecordCount(count, apiResponse.data.totalElements, newSortArray);
                                const pageNum = thisObject.state.pageNumber + 1;
                                const formattedData = apiResponse.data.content;
                                props.setAggridCaseData(formattedData, pageNum, newSortArray); 
                                flushSync(()=> {
                                  thisObject.setState({
                                    pageNumber: pageNum,
                                    isLoading: false,
                                    isSortClicked: false,
                                  });
                                });
                                const isLastPage = apiResponse?.data?.last;
                                const rowCount = isLastPage ? (apiResponse.data.pageable.offset + formattedData.length) : undefined;
                                params.success({
                                    rowData: formattedData,
                                    rowCount: rowCount,
                                });
                                setTimeout(() => {
                                    thisObject.autoSizeAllColumns(params?.api?.getColumnDefs());
                                }, 100);
                            })
                            .catch((error) => {
                                props.setDataError();
                                flushSync(()=> {
                                    thisObject.setState({
                                    isSortClicked: false,
                                    });
                                });
                                params.fail();
                                console.log('Error Occured while fetching unmatched case details', error);
                            });
                    }
                } else {
                    params.success({
                        rowData: [],
                        rowCount: totalRecords,
                    });
                }
            }
        }
    }

    topBorderVariations = () => {
        /*
          this.state.isrelatedSearchLoaded is "Related Search Dispute Overview"
          this.props.isRelatedTransactionGridOpen is "Related Transaction Grid"
          this.props.dataTransactionGridStatus is "Data Search Related Transaction"
        */
            if (!this.props.isRelatedTransactionGridOpen) {
                if (this.props.stageType.length > 0 && this.props.stageType[0].caseStageDetail.disputeStageName === 'Unidentified-Stage') {
                   return 'topBorder__unidentifiedTrans'
                    } else if (this.props.reasonCode.amexDisputeReasonCode === __OP1_REASON_CODE__) {
                        return 'topBorder__op1_data_search'
                    } else if (this.props.stageType.length === 0 && !this.state.isNextPage && this.props.reasonCode.amexDisputeReasonCode !== __OP1_REASON_CODE__) {
                        return 'topBorder__generic'
                    } else if (this.props.stageType.length === 0 && this.state.isNextPage === true && this.props.reasonCode.amexDisputeReasonCode !== __OP1_REASON_CODE__) {
                        return 'topBorder__genericIsNextpageTrans'
                } else {
                    return 'topBorder'
                }
            } else {
               return 'topBorder__relatedTrans'
            }
        }
    
        detailedCaseHeader = () => {
        /*
          this.state.isrelatedSearchLoaded is "Related Search Dispute Overview"
          this.props.isRelatedTransactionGridOpen is "Related Transaction Grid"
          this.props.dataTransactionGridStatus is "Data Search Related Transaction"
        */
       
            if (this.props.isRelatedTransactionGridLoaded === true && (this.props.stageType.length > 0 && this.props.stageType[0].caseStageDetail.disputeStageName !== 'Unidentified-Stage')) {
                return 'main-content--header reports-container--header'
            } else {
                if (this.props.stageType.length > 0 && this.props.stageType[0].disputeStageName === 'Unidentified-Stage') {
                    return 'data-search-unidentified-transaction-grid'
                } else if (this.props.reasonCode.amexDisputeReasonCode === __OP1_REASON_CODE__) {
                    return 'main-content-header-op1'
                } else if (this.props.stageType.length === 0) {
                    return 'main-content-header-generic'
                } else {
                    return 'data-search-transaction-grid'
                }
            }
        }

    showRecords = () => {
        let apiUrl = this.state.apiUrl;
        
        if(apiUrl.split("/").pop() === 'transactions' && !this.props.isRelatedTransactionGridOpen){
            return 'data_trans_showRecords'
        }else if(apiUrl.split("/").pop() === 'authdata'){
            return 'data_auth_showRecords'
        }else if(apiUrl.split("/").pop() === 'merchantdetails'){
            return 'data_merch_showRecords'
        }else{
            return 'related_showRecords'
        }
    }

    render() {
        const auth = loadState('auth');
        const userPermission = auth.user.parsedPermissions;
        return (
            <div>
                {this.state.setSize == true &&
                    this.checkSize()
                }
                {!this.state.isLoading && !this.state.isTableVisible &&
                    <div className={this.detailedCaseHeader()} >
                        <h1>
                            {
                                this.getColumnListForTableById() !== undefined
                                    ?
                                    this.getColumnListForTableById().headerName
                                    :
                                    ''
                            }
                        </h1>
                    </div>
                }
                <div 
                    className={this.topBorderVariations()}
                >

                    {this.state.isVisible && !this.props.isRelatedTransactionGridOpen && (
                        <div 
                        className="gd-filter-pane__wrapper" 
                        style={{ marginBottom: 'auto' ,zIndex:4 }}>
                            <FilterPane
                                userPermission={userPermission}
                                applyFilters={this.applyFilters}
                                closeFilterPane={this.closeFilterPane}
                                currentValues={this.state.activeFilters}
                                dateFormat={this.state.dateFormat}
                                filterList={this.state.filters}
                                isVisible={this.state.isVisible}
                                translations={getFilterTranslations()}
                                reportName="Received Disputes_filterPane"
                                extraClass="some-class"
                                resetScrollPos={this.resetScrollPos}
                                setSearchType={this.props.setSearchType}
                                appSearchElement="appSearchElement"
                                cancelButtonStyle={{ color: '#3a3c44' }}
                                primaryButtonStyle={{ width: 112, marginRight: 16 }}
                            />


                        </div>

                    )}
                    {
                        this.state.isLoading && <BVLoader20 />
                    }
                    {!this.state.isLoading && !this.state.caseDataErr && this.state.isTableVisible && this.state.isGridOpen && this.state.dataColumns?.length > 0 && <div className={this.state.drawerOpen ? 'opacity' : ''} 
                    ref={((ref) => (this.gdTable = ref))}>
                        <GridAccordion
                            isOpen={this.state.isAccordionOpen}
                            toggleAccordion={this.toggleThisAccordion}
                            merchantDetail={ this.props.isRelatedTransactionGridOpen
                                ? {
                                    merchantName: this.props.merchantDetails.merchantName,
                                    merchantNumber: this.props.merchantDetails.merchantNumber,
                                    cardNumber: this.props.merchantDetails.cardNumber,
                                } : null
                            }
                            rowHeight={37}
                            isGridCompact={true}
                            isCellborder={true}
                            tableCss="tableAppSearch"
                            className={this.state.drawerOpen ? "opacity" : ""}
                            report={this.state.structureMetaData}
                            data={this.state.caseData}
                            dateFormat={this.state.dateFormat}
                            totalPages={this.state.totalPages}
                            totalRecords={this.state.totalRecords}
                            recordsCountText={{ showingRecords: 'Showing records', preposition: 'of' }}
                            currentPage={this.state.currentPage}
                            recordsShown={this.state.recordsShown}
                            sort={this.state.gridSortArray}
                            handleSort={this.handleSort}
                            pageHandler={this.pageHandler}
                            translations={getTranslations()}
                            filterText={this.state.filterText}
                            tableHeight={286}
                            contentWrapRequired={false}
                            onSearchChange={this.onSearchChange}
                            isNextPage={this.state.isNextPage}
                            exporting={this.state.exporting}
                            exportAction={this.exportAction}
                            filterExportIsVisible={this.state.filterExportIsVisible}
                            toggleFileExport={this.toggleFileExport}
                            actionButtonText="Options"
                            paginationRequired={this.state.paginationRequired}
                            rowActionClick={this.rowActionClick}
                            titleRequired={true}
                            loadDataOnScroll={this.loadDataOnScroll}
                            openBoxDropDownStyle={{
                                width: 200,
                                marginLeft: -100,
                                fontSize: 'initial'
                            }}
                            isLoading={this.state.isLoadingComplete}
                            saveCurrentlyVisibleColumns={this.saveCurrentlyVisibleColumns}
                            addIconsToGDTableHeadersList={this.addIconsToGDTableHeadersList}
                            appliedFilterParams={this.state.appliedFilters}
                            serverSideData={this.serverSideData}
                            setRecordCount={this.setRecordCount}
                            setAggridCaseData={this.setAggridCaseData}
                            isAgGrid={true}
                            setDataError={this.setDataError}
                            setFilterModelAttribute={this.setFilterModelAttribute}
                            appSerchUrl={this.state.apiUrl}
                            actionWidth={140}
                            exportFileName={this.getColumnListForTableById().headerName}
                            agLoader ={this.state.agLoader}
                            recordCountRequired={false}
                            isPagable={false}
                            isLocalSort={false}
                            isTransactionFlag ={this.getColumnListForTableById().id == "1" ? true : false}
                            tableName={this.getColumnListForTableById().headerName}
                            isDataSearchTransaction={true}
                            customFooter={<div className='customFooterButtonContainer'>
                                <div className={this.showRecords()}>
                                {this.state.totalRecords > 0 ? <span>Showing records <span className='boldNumericText'>{this.state.recordsShown}</span> of <span className='boldNumericText'>{this.state.totalRecords}</span></span> : ''}
                                </div>
                                <Button
                                    action={this.onCloseButtonClick}
                                ><span className='customFooterButton'>Close</span>
                                </Button></div>}
                        />
                    </div>}
                    {this.state.caseDataErr && !this.state.loading && (
                        <div style={{ paddingTop: 105, paddingBottom: 20 }}><EmptyState
                            translations={{ "emptyStateHeading": "Data not available.", "emptyStateDescription": "Please try again later." }}
                        /></div>
                    )}
                    {
                        this.state.drawerOpen && <div className="drawer open">
                            <GDDetailView
                                type="report"
                                data={this.state.caseData[this.state.selectedKeyIndex]}
                                goBack={this.toggleDrawer}
                                goToPreviousRecord={this.goToPreviousRecord}
                                goToNextRecord={this.goToNextRecord}
                                structure={[].concat(this.state.structureMetaData)}
                                preferences={{}}
                                recordCountSize={this.state.caseData.length}
                                selectedKeyIndex={this.state.selectedKeyIndex}
                            />
                        </div>
                    }
                    {this.state.isRequiredFilter &&
                    <ImagePortal>
                        <ResponseBanner
                            titleStyle={{ color: 'light-green' }}
                            descriptionStyle={{ color: 'grey' }}
                            valueStyle={{ color: 'black' }}
                            title="Validation Error"
                            description={this.state.bannerDescription}
                            type="danger"
                            onClose={this.closeBanner}
                            cancelButtonText="DISMISS"
                            primaryButtonActionValue=""
                            primaryButtonText="OKAY, DO SOMETHING TO FIX IT"
                            primaryButtonAction={this.closeBanner}
                        />
                        </ImagePortal>
                    }
                    {this.state.isTransactionCaseAttached &&
                    <ImagePortal>
                        <ResponseBanner
                            isPrimarSecondaryButtonCombo={true}
                            titleStyle={{ color: 'light-green' }}
                            descriptionStyle={{ color: 'grey' }}
                            valueStyle={{ color: 'black' }}
                            title="Transaction Attached Successfully"
                            description={this.state.bannerDescription}
                            type="success"
                            onClose={this.closeBanner}
                            cancelButtonText="UNDO"
                            primaryButtonActionValue=""
                            primaryButtonText="DISMISS"
                            primaryButtonAction={this.closeBanner}
                            secondaryButtonAction={this.undoAttachedTransaction}
                        />
                        </ImagePortal>
                    }
                    {this.state.isTransactionCaseAttachedError &&
                    <ImagePortal>
                        <ResponseBanner
                            cancelOnly={true}
                            titleStyle={{ color: 'light-green' }}
                            descriptionStyle={{ color: 'grey' }}
                            valueStyle={{ color: 'black' }}
                            title={this.state.bannerResponseMessage}
                            description=""
                            type="danger"
                            onClose={this.closeBanner}
                            cancelButtonText="DISMISS"
                        />
                        </ImagePortal>
                    }
                    {this.state.isTransactionUnattached &&
                    <ImagePortal>
                        <ResponseBanner
                            cancelOnly={true}
                            titleStyle={{ color: 'light-green' }}
                            descriptionStyle={{ color: 'grey' }}
                            valueStyle={{ color: 'black' }}
                            title={this.state.bannerResponseMessage}
                            description=""
                            type="success"
                            onClose={this.closeBanner}
                            cancelButtonText="DISMISS"
                        />
                        </ImagePortal>
                    }
                </div>
            </div>
        );
    }
}

AppSearch.propTypes = {
    setSearchType: PropTypes.func.isRequired,
    searchTypeId: PropTypes.string,
    setNotification: PropTypes.func,
    closeNotification: PropTypes.func,
    isRelatedTransactionGridOpen: PropTypes.bool,
    merchantDetails: PropTypes.object,
    isRelatedTransactionGridLoaded: PropTypes.bool,
};

AppSearch.defaultProps = {
    searchTypeId: '',
    isRelatedTransactionGridOpen: false,
    merchantDetails: {},
    isRelatedTransactionGridLoaded: false,
};

const mapStateToProps = (state) => ({
    addCurrentCaseNumber: state.transactionSearch.addCurrentCaseNumber,
    dataColumns: state.appSearch.columns,
    isRelatedTransactionGridOpen: state.toggleAppSearchPanelReducer.isRelatedTransactionGridOpen,
    merchantDetails: state.setMerchantDetailsReducer.merchantDetails,
    isRelatedTransactionGridLoaded: state.toggleAppSearchPanelReducer.isRelatedTransactionGridLoaded,
    reasonCode: state.reasonCode,
    stageType: state.caseInfo.openCases
});

const mapDispatchToProps = (dispatch) => {
    return {
        setDrawerOpenFlag: (isDrawerActive) => {
            dispatch(setDrawerOpenFlag(isDrawerActive));
        },
        setSearchOpenFlag: (isSearchActive) => {
            dispatch(setSearchOpenFlag(isSearchActive));
        },
        fetchDataColumns: (pageId, searchPage) => {
            dispatch(fetchDataColumns(pageId, searchPage));
        },
        setNotification: (banner) => dispatch(dangerNotificationBanner(banner)),
        closeNotification: () => dispatch(closeNotificationBanner()),
        toggleAppSearchPanelAction: (isRelatedTransactionGridOpen) => {
            dispatch(toggleAppSearchPanelAction(isRelatedTransactionGridOpen));
        },
        setRelatedGridLoadedAction: (isRelatedTransactionGridLoaded) => {
            dispatch(setRelatedGridLoadedAction(isRelatedTransactionGridLoaded));
        },
        setDataSearchTrasactionGridProp: (dataTransactionGridStatus, dataSearchPrevPage, dataSearchNextPage) => {
            dispatch(setDataSearchTrasactionGridProp(dataTransactionGridStatus, dataSearchPrevPage, dataSearchNextPage));
        },
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(AppSearch);
  /* eslint-enable global-require, class-methods-use-this */
